import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { AlertComponent } from '../../objects/alert/alert/alert.component';
import { LoadingComponent } from '../../objects/loading/loading.component';
import { InfoComponent } from '../../objects/info/info/info.component';
import { TipoProducto } from 'src/app/Models/tipoproducto/tipo-producto';
import { DataService } from 'src/app/Service/data.service';

@Component({
  selector: 'app-tipo-producto',
  templateUrl: './tipo-producto.component.html'

})
export class TipoProductoComponent implements OnInit {
  @ViewChild('btnshow', null) btnshow: ElementRef;
  @ViewChild('btnclose', null) btnclose: ElementRef;
  
  @ViewChild(AlertComponent, null) alert: AlertComponent;
  @ViewChild(LoadingComponent, null) loading: LoadingComponent;
  @ViewChild(InfoComponent, null) info: InfoComponent;
  public isShow: boolean = false;
  public pagina: number = 0;
  public tipoproductos:TipoProducto[]=[];
  public tipoproducto:TipoProducto= new TipoProducto();
  public isEdit:boolean=false;
  public funcion:Function=null;
  public pagtipoproducto:any;
  public adddescripcion:boolean= false;
  constructor(private data: DataService) { }

  ngOnInit() {
  }

  public show(affterfunction:Function = null) {
      this.funcion= affterfunction;
      this.isShow = true;
      this.showTab(1);
      setTimeout(() => {
          this.btnshow.nativeElement.click();
          this.GetData();
      }, 10);
  }

  GetData(){
      this.loading.show("cargando Tipos Prod..");
      this.data.select(this.data.api.tipoproducto,'fill').subscribe(r=>{
          this.loading.hide();
          if(this.data.Exists(r[0].id)){
            this.tipoproductos = r;
          }
      },e=>{this.loading.hide(); this.info.error(e,()=>{this.showTab(1)})})
  }
  ShowNewItem(){
      this.isEdit = false;
      this.showTab(2);
      this.tipoproducto = new TipoProducto();
      this.adddescripcion=false;
  }
  ShowEditItem(i){
      this.isEdit = true;
      this.showTab(2);
      this.tipoproducto = this.tipoproductos[i];
      if(this.tipoproducto.descripcion != ""){this.adddescripcion = true;}else{this.adddescripcion = false;}
  }
  showTab(i) {
      this.pagina = i;
  }

  close(){
      this.btnclose.nativeElement.click();
      setTimeout(() => {
          if(this.funcion != null){
              this.funcion();
          }
      }, 10);
  }

  Save(){
      if(this.isEdit){
          this.loading.show("Actualizando..");
          this.tipoproducto.current_user = this.data.getCurrentUser().id;
          this.data.update(this.data.api.tipoproducto,'all',this.tipoproducto).subscribe(r=>{
              this.loading.hide();
              this.info.show(r.message,r.result,null,null,()=>{this.showTab(1);this.GetData();})
          },e=>{this.loading.hide(); this.info.error(e,()=>{this.showTab(1)})})
      }
      else{
          this.loading.show("Registrando..");
          this.tipoproducto.current_user = this.data.getCurrentUser().id;
          this.data.insert(this.data.api.tipoproducto,this.tipoproducto).subscribe(r=>{
              this.loading.hide();
              this.info.show(r.message,r.result,null,null,()=>{this.showTab(1);this.GetData();})
          },e=>{this.loading.hide(); this.info.error(e,()=>{this.showTab(1)})})
      }
      if(this.funcion != null){
          this.funcion();
      }
  }
}
